import "./PairingList.scss";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { GridSortModel } from "@mui/x-data-grid-pro";
import ContextMenu from "../../components/ContextMenu/ContextMenu";
import DetailView from "../../components/DetailView/DetailView";
import Loader from "../../components/Loader/Loader";
import Modal from "../../components/Modal/Modal";
import PairingListBody from "../../components/PairingListBody/PairingListBody";
import PairingListHeader from "../../components/PairingListBody/ParingListHeader";
import { pushSiteInfo, registerPageInfo } from "../../helpers/analyticsHelper";
import {
  generatePrevNMonths,
  getFormattedMonth,
  getMonth,
  getYear,
} from "../../helpers/dateHelpers";
import { generateColumns } from "../../helpers/tableHelpers";
import DbmInfo from "../../models/DbmInfo";
import { FreezePeriodInterface } from "../../models/FreezePeriodInterface";
import ModalInterface from "../../models/ModalInterface";
import { SearchStateInterface } from "../../models/SearchInterface";
import { useAuth } from "../../providers/Auth";
import { useColumnPresets } from "../../providers/ColumnPresets";
import { useFreezePeriod } from "../../providers/FreezePeriod";
import { useGeneralPairing } from "../../providers/GeneralPairing";
import { usePairingById } from "../../providers/PairingById";
import { usePairingList } from "../../providers/PairingListProvider";
import { useProfile } from "../../providers/Profile";

const PairingList = () => {
  const columnPresetsContext = useColumnPresets();
  const freezePeriodContext = useFreezePeriod();
  const generalPairingContext = useGeneralPairing();
  const pairingByIdContext = usePairingById();
  const pairingListContext = usePairingList();
  const profileContext = useProfile();

  const [anchorEl, setAnchorEl] = useState(null);
  const [colVisibility, setColVisibility] = useState({});
  const [currentCategory, setCurrentCategory] = useState<any>({});
  const [currentPairingMonthData, setCurrentPairingMonthData] =
    useState<FreezePeriodInterface>();
  const [isDeletedTemp, setIsDeleted] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [newCategoryName, setNewCategoryName] = useState(""); // TODO: remove ?
  const [priorSelectedPairingId, setPriorSelectedPairingId] = useState("");
  const [selectedPairingId, setSelectedPairingId] = useState("");
  const [xGridColumns, setXGridColumns] = useState<any>([]);

  const location = useLocation();
  const selectedPairingIdRef = useRef("");
  const { t } = useTranslation();

  selectedPairingIdRef.current = selectedPairingId;

  let pairingPackageSelectedDate = "";
  let pairingPackageToSelectDate = "";
  if (
    location !== null &&
    location?.state !== null &&
    location?.state !== undefined
  ) {
    let { pairingPackageSelectedDate: selectedDate, pairingPackageToDate } = location?.state;
    pairingPackageSelectedDate = selectedDate;
    pairingPackageToSelectDate = pairingPackageToDate;
  }

  const [searchState, setSearchState] = useState<SearchStateInterface>({
    selectedDate: '',
    toSelectDate: '',
    selectedBase: profileContext.profile.results?.baseLocation as string,
    selectedEquipment: profileContext.profile.results?.equipment as string,
    selectedPosition: profileContext.profile.results?.position as string,
  });

  useEffect(() => {
    if (
      !freezePeriodContext.freezePeriodData.pairingFreeze ||
      freezePeriodContext.loading
    ) {
      return;
    }
    setCurrentPairingMonthData({
      ...freezePeriodContext.freezePeriodData.pairingFreeze.filter(
        (val) => val
      )[0],
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [freezePeriodContext]);

  const [dataList, setDataList] = useState<any[]>([]);
  const [dbmInfo, setDbmInfo] = useState<DbmInfo>({});
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const toggleSearchDates = () => {
    const newSearchDates = {
      selectedDate: searchState.toSelectDate as string,
      toSelectDate: searchState.selectedDate,
    };
    setSearchState({
      ...searchState,
      ...newSearchDates,
    });
  };

  const handleOptionsOpen = (pairingId, categoryName, categoryId, event) => {
    setSelectedPairingId(pairingId);
    setCurrentCategory({
      name: categoryName,
      id: categoryId,
      isTop: true,
      isBottom: true,
      isHeader: false,
    });
    setMenuAnchorEl(event.currentTarget);
  };

  const removeDeletedPairing = async (
    pairingId,
    categoryname,
    categoryid,
    isDeleted
  ) => {
    setSelectedPairingId(pairingId);
    setIsDeleted(isDeleted);
    setCurrentCategory({
      name: categoryname,
      id: categoryid,
      isTop: true,
      isBottom: true,
      isHeader: false,
    });
    setOpen(true);
  };

  const handleOptionsClose = () => {
    setMenuAnchorEl(null);
  };

  useEffect(() => {
    if (!profileContext.profile.results || !currentPairingMonthData) {
      return;
    }

    let selectedDate = getFormattedMonth(currentPairingMonthData.pairingMonth, currentPairingMonthData.pairingYear);
    let toSelectDate = getFormattedMonth(currentPairingMonthData.pairingMonth === 1 ? 12 : currentPairingMonthData.pairingMonth-1, currentPairingMonthData.pairingMonth === 1 ? currentPairingMonthData.pairingYear-1 : currentPairingMonthData.pairingYear);
    if (
      currentPairingMonthData &&
      currentPairingMonthData.dbmPosted === false
    ) {
      selectedDate = `${generatePrevNMonths(13, 2, new Date(currentPairingMonthData.pairingYear, currentPairingMonthData.pairingMonth - 1))[1].month} ${generatePrevNMonths(13, 2, new Date(currentPairingMonthData.pairingYear, currentPairingMonthData.pairingMonth - 1))[1].year}`;
      toSelectDate = `${generatePrevNMonths(13, 2, new Date(currentPairingMonthData.pairingYear, currentPairingMonthData.pairingMonth - 1))[2].month} ${generatePrevNMonths(13, 2, new Date(currentPairingMonthData.pairingYear, currentPairingMonthData.pairingMonth - 1))[2].year}`;
    }

    setSearchState({
      ...searchState,
      selectedDate: pairingPackageSelectedDate || selectedDate,
      toSelectDate: pairingPackageToSelectDate || toSelectDate,
      selectedBase: profileContext.profile.results?.baseLocation,
      selectedEquipment: profileContext.profile.results?.equipment,
      selectedPosition: profileContext.profile.results?.position,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileContext.profile.results, currentPairingMonthData]);

  useEffect(() => {
    if(!searchState.selectedDate) return;
    pairingListContext.getPairingListData(searchState);
    generalPairingContext.getList(searchState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState.selectedDate]); // Both getPairingListData and getList is solely dependent on selectedDate and no other property of searchState

  useEffect(() => {
    if (!pairingListContext.pairingListData) {
      return;
    }
    setDataList(pairingListContext.pairingListData.listobj);
    setDbmInfo({
      dbm: pairingListContext.pairingListData.dbm,
      mbg: pairingListContext.pairingListData.mbg,
    });
  }, [pairingListContext.pairingListData]);

  useEffect(() => {
    if (!selectedPairingId) {
      return;
    }
    if (!isDeletedTemp) {
      pairingByIdContext.getPairingDataById(selectedPairingId, searchState);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPairingId]);

  useEffect(() => {
    if (!columnPresetsContext.columnPreferences.columns || !colVisibility) {
      return;
    }
    let temp = {};
    columnPresetsContext.columnPreferences.columns.forEach((obj) => {
      temp[obj.internalCode] = obj.preferredDisplay;
    });
    setColVisibility({ ...temp });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnPresetsContext.columnPreferences.columns]);

  useEffect(() => {
    if (!columnPresetsContext.columnPreferences.columns) {
      return;
    }

    const renderCells = {
      pairingId: (params) => (
        <span
          onClick={(e) =>
            handleDetailView(params.row.pairingId, e, params.row.isDeleted)
          }
          className={
            params.row.isDeleted
              ? "pairing-id pairing-id-isDeleted"
              : "pairing-id"
          }
        >
          {params.row.pairingId}
        </span>
      ),
      actions: (params) => (
        <div style={{ cursor: "pointer" }}>
          {!params.row.isDeleted ? (
            <span
              onClick={(e) =>
                handleOptionsOpen(
                  params.row.pairingId,
                  params.row.categoryname,
                  params.row.categoryid,
                  e
                )
              }
            >
              <i className="icon-action-overflow" />
            </span>
          ) : (
            <span
              onClick={(e) =>
                removeDeletedPairing(
                  params.row.pairingId,
                  params.row.categoryname,
                  params.row.categoryid,
                  params.row.isDeleted
                )
              }
              className="pairing-list-remove-link"
            >
              Remove
            </span>
          )}
        </div>
      ),
    };
    setXGridColumns(generateColumns(renderCells, t));
    setSortModel([
      {
        field: "pairingId",
        sort: "asc",
      },
    ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const removeFavorite = async () => {
    if (!currentCategory.name || !currentCategory.id || !selectedPairingId) {
      return;
    }
    setMenuAnchorEl(null);
    await generalPairingContext.removePairing(
      currentCategory.name,
      currentCategory.id,
      searchState,
      selectedPairingId
    );
    handleClose();
    pairingListContext.getPairingListData(searchState);
  };

  /**
   * we are setting thesse states in the PairingListBody component below
   * formated as per below with setCurrentCategory(
   * name: category.categoryName,
   * id: category.categoryId,
   * isTop,
   * isBottom)
   */
  const removeCategory = async () => {
    setMenuAnchorEl(null);
    await generalPairingContext.removePairing(
      currentCategory.name,
      currentCategory.id,
      searchState
    );
    handleClose();
    await pairingListContext.getPairingListData(searchState);
    generalPairingContext.getList(searchState);
  };

  const favoriteData: ModalInterface = {
    title: t("pairingList.removeItemTitle"),
    question: `${t("pairingList.removeItemText1")} ${selectedPairingId} ${t(
      "pairingList.removeItemText2"
    )}`,
    deleteLabel: t("pairingList.removeItemRemove"),
    cancelLabel: t("pairingList.removeItemCancel"),
    handleDelete: removeFavorite,
    handleCancel: handleClose,
  };

  const modalData: ModalInterface = {
    title: t("pairingList.deleteTitle"),
    question: t("pairingList.deleteQuestion"),
    description: t("pairingList.deleteText") ?? "",
    deleteLabel: t("pairingList.delete"),
    cancelLabel: t("pairingList.cancel"),
    handleDelete: removeCategory,
    handleCancel: handleClose,
  };

  const handleDetailView = (id, event, isDeleted) => {
    if (!isDeleted) {
      setPriorSelectedPairingId(selectedPairingIdRef.current);
      setSelectedPairingId(id);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleSnapClose = () => {
    setAnchorEl(null);
  };

  /**
   * Prevent the clickAway function from firing after handleDetailView when a user clicks on a different Pairing ID while a DetailView is already open
   * If user clicks on the same Pairing ID, close the DetailView
   */
  const handleDetailViewClickAway = (event) => {
    if (event.target.className === "pairing-id") {
      if (event.target.innerText === priorSelectedPairingId) setAnchorEl(null);
    } else {
      setAnchorEl(null);
    }
  };

  const handleMoveToCategory = async (category) => {
    setMenuAnchorEl(null);
    if (!currentCategory.name || !currentCategory.id || !selectedPairingId) {
      return;
    }
    await generalPairingContext.removePairing(
      currentCategory.name,
      currentCategory.id,
      searchState,
      selectedPairingId
    );
    await generalPairingContext.addToCategory(
      searchState,
      category.name,
      selectedPairingId
    );

    pairingListContext.getPairingListData(searchState);
  };

  const handleMoveCategory = async (moveup) => {
    setMenuAnchorEl(null);
    const pairingsFromFavorites =
      pairingListContext.pairingListData.listobj.map((f) => ({
        name: f.categoryName,
        id: f.categoryId,
        sortOrder: parseInt(f.sortOrder),
      }));
    const indexToUpdate: any = pairingsFromFavorites
      .sort((a, b) => a.sortorder - b.sortorder)
      .map((f, i) => (f.name === currentCategory.name ? i : false))
      .filter((f) => f !== false)[0];
    const newList = [...JSON.parse(JSON.stringify(pairingsFromFavorites))]
      .map((f) => ({
        name: f.name,
        id: f.id,
        sortOrder: parseInt(f.sortOrder),
      }))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    const updatedNewList = newList.map((list) => ({
      ...list,
      blockyear: getYear(searchState.selectedDate),
      blockmonth: getMonth(searchState.selectedDate),
    }));

    if (moveup && indexToUpdate !== 0) {
      updatedNewList[indexToUpdate - 1].sortOrder =
        updatedNewList[indexToUpdate - 1].sortOrder + 1;
      updatedNewList[indexToUpdate].sortOrder =
        updatedNewList[indexToUpdate].sortOrder - 1;
    } else if (
      !moveup &&
      indexToUpdate !== generalPairingContext.list.length - 1
    ) {
      updatedNewList[indexToUpdate + 1].sortOrder =
        updatedNewList[indexToUpdate + 1].sortOrder - 1;
      updatedNewList[indexToUpdate].sortOrder =
        updatedNewList[indexToUpdate].sortOrder + 1;
    } else {
      return;
    }
    await pairingListContext.moveCategory(updatedNewList);
    pairingListContext.getPairingListData(searchState);
  };

  const handleNameChange = async () => {
    setMenuAnchorEl(null);
    await pairingListContext.updateCategoryName(
      currentCategory.id,
      newCategoryName
    );
    pairingListContext.getPairingListData(searchState);
    generalPairingContext.getList(searchState);
  };

  const user = useAuth();
  useEffect(() => {
    if (user.loading) return;
    if (!profileContext.profile.results) return;

    pushSiteInfo(user.user, profileContext.profile);
    registerPageInfo("my access app|planning & bidding|my pairings list", {
      level1: "my access app",
      level2: "planning & bidding",
      level3: "my pairings list",
      level4: null,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, profileContext.profile.results]);

  return profileContext.loading || pairingListContext.loading ? (
    <Loader />
  ) : (
    <>
      <div className="pairing-data">
        <Modal
          open={open}
          handleClose={handleClose}
          data={currentCategory.isHeader ? modalData : favoriteData}
        />
        <PairingListHeader
          searchState={searchState}
          toggleMonth={toggleSearchDates}
        />
        <PairingListBody
          searchState={searchState}
          dataList={dataList}
          setMenuAnchorEl={setMenuAnchorEl}
          setCurrentCategory={setCurrentCategory}
          xGridColumns={xGridColumns}
          sortModel={sortModel}
          setSortModel={setSortModel}
          colVisibility={colVisibility}
          setColVisibility={setColVisibility}
          dbmInfo={dbmInfo}
          presetDropdownOptions={columnPresetsContext.columnPresets.presetNames}
        />
        <DetailView
          searchState={searchState}
          anchorEl={anchorEl}
          selectedPairingId={selectedPairingId}
          handleSnapClose={handleSnapClose}
          handleDetailViewClickAway={handleDetailViewClickAway}
        />
        <ContextMenu
          menuAnchorEl={menuAnchorEl}
          handleMoveToCategory={handleMoveToCategory}
          handleOptionsClose={handleOptionsClose}
          setNewCategoryName={setNewCategoryName}
          newCategoryName={newCategoryName}
          currentCategory={currentCategory}
          handleMoveCategory={handleMoveCategory}
          setOpen={setOpen}
          dataList={dataList}
          handleNameChange={handleNameChange}
          colVisibility={colVisibility}
        />
      </div>
    </>
  );
};

export default PairingList;
